import { useState } from 'react'
import { Icon } from '@iconify/react'

type ImageProps = {
  src: string | null
  alt: string
  /** Wrap the image in a link to the full-size photo. */
  linkClassName?: string
}

/**
 * The ID photo, or — once its signed link has expired (or there's nothing
 * displayable) — a neutral note instead of a broken image.
 */
export const SenderIdPhoto = ({ src, alt, linkClassName }: ImageProps) => {
  const [failedSrc, setFailedSrc] = useState<string | null>(null)

  if (!src || failedSrc === src) {
    return (
      <span className='sender-id-expired'>
        <Icon icon='mdi:shield-lock-outline' />
        ID on file — reload to view
      </span>
    )
  }
  const img = <img src={src} alt={alt} onError={() => setFailedSrc(src)} />
  return linkClassName ? (
    <a className={linkClassName} href={src} target='_blank' rel='noreferrer'>
      {img}
    </a>
  ) : (
    img
  )
}
